import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AuthLockScreen from "../pages/Authentication/AuthLockScreen";
import { DASHBOARD_PAGE, PRAMETRAGE_PAGE, VVINAL_PAGE, DATABASE_VEHICULE_PAGE, DATABASE_CLIENT_PAGE, DATABASE_VEHICULE_FORM, DATABASE_VEHICULE_EDIT, DATABASE_CLIENT_FORM, DATABASE_CLIENT_EDIT  } from "./routeConstants";
import DashboardPage from "../modules/dashboard/pages/DashboardPage";
import ParametragePage from "../modules/parametrage/index";
import VVinalPage from "../modules/valeurVinal/vVinalPage";
import VehiculePage from "../modules/database/VehiculePage";
import ClientPage from "../modules/database/ClientPage";
import VehiculeForm from "../modules/database/VehiculeForm";
import ClientForm from "../modules/database/ClientForm";


const authProtectedRoutes = [
	{ path: DASHBOARD_PAGE, component: <VehiculePage /> },


	{ path: PRAMETRAGE_PAGE, component: <ParametragePage /> },
	{ path: VVINAL_PAGE, component: < VVinalPage/> },

	{ path: DATABASE_VEHICULE_PAGE, component: < VehiculePage/> },
	{ path: DATABASE_VEHICULE_FORM, component: <VehiculeForm /> },
	{ path: DATABASE_VEHICULE_EDIT, component: <VehiculeForm /> },

	{ path: DATABASE_CLIENT_PAGE, component: < ClientPage/> },
	{ path: DATABASE_CLIENT_FORM, component: <ClientForm /> },
	{ path: DATABASE_CLIENT_EDIT, component: <ClientForm /> },	

	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: <Navigate to="/login" /> },
];

const publicRoutes = [
	{ path: "/logout", component: <Logout /> },
	{ path: "/login", component: <Login /> },
	{ path: "/forgot-password", component: <ForgetPwd /> },
	{ path: "/lock-screen", component: <AuthLockScreen /> },
];

export { authProtectedRoutes, publicRoutes };
